export default "__VITE_ASSET__d1054c61__"